export default __webpack_public_path__ + "static/media/mg-icon.651fdc6f.webp";